module.exports = __webpack_public_path__ + "static/media/1.14b548b5.jpeg";